import { atom } from "recoil";

const statusMessageState = atom({
  key: "statusMessageState",
  default: [],
});

export default statusMessageState;
